import { SadBop } from "../../components/404/SadBop";
import React from "react";
import { Button } from "../../components/general/Button/Button";
import { SocialsSection } from "../../components/404/SocialsSection";
import { Spacer } from "../../components/general/Spacer/Spacer";
import { NotFoundButtonsContainer } from "./elements/NotFoundButtonsContainer";
import { useMediaQuery } from "usehooks-ts";
import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { css } from "@emotion/react";

export const NotFound: React.FC = () => {
  const matchesMediaQuery = useMediaQuery("(max-width: 420px)");
  const theme = GlobalStore.useState(s => s.theme);

  return (
    <Container>
      <SadBop />
      <Text textStyle="Title" size="XXL">
        Oops! We couldn't find that page.
      </Text>
      <Text
        textStyle="Paragraph"
        size="XL"
        color={theme.font.secondary.default}
        textCss={css`
          margin: 8px 0 16px 0;
        `}
      >
        No worries, though! We'd be more than happy to help you get started with trading or learning
        about Bebop instead. How does that sound?
      </Text>
      <NotFoundButtonsContainer>
        <Button navigateTo="/trade" text={"Start trading"} size="Medium" height={44} />
        <Button
          navigateTo="/"
          buttonType={"secondary"}
          text={"Learn about Bebop"}
          size={"Medium"}
          height={44}
        />
      </NotFoundButtonsContainer>
      <Spacer height={matchesMediaQuery ? "1.5rem" : "3rem"} />
      <SocialsSection theme={theme} />
    </Container>
  );
};

// Sub-components

export const Container = styled.div`
  display: grid;
  grid-template-columns: 36rem;
  justify-content: center;
  place-items: start center;
  margin: 7rem auto;
  background: ${props => props.theme.surface.main.primary.default};
  border-radius: 26px;
  width: fit-content;
  height: fit-content;
  text-align: center;
  padding: 44px 14px;
  position: relative;
  z-index: 1;
  letter-spacing: 0;

  @media (max-width: 576px) {
    grid-template-columns: 90%;
    margin: 2rem 0 6rem;
  }
`;
